import $ from "jquery";
import {addActiveBackdrop} from "../modal-backdrop";
import {renderModal} from "../render-modal";
import {AUTH_MODAL} from "Core/links";

export const bindEventsToAuthModalCallingBtn = () => {
    $('#signin-button').on("click", function (e) {
        addActiveBackdrop();
        renderModal(AUTH_MODAL, '#signup-social');
    });
};
